import styles from './cover-section.module.scss'

export const CoverSection = () => {
  return (
    <div className={styles.coverSection} >
      <h1>This is<br /><span>Ivan</span><br /><span>Velikanov</span></h1>
    </div>
  )
}